import getPropsValuesMixin from "@/helpers/Maps/getPropsValuesMixin.js";
import _ from "lodash";
import MapElementMixin from "./maps-mixin";

const props = {
    draggable: {
        type: Boolean,
        twoWay: true,
        default: false
    },
    position: {
        type: Object,
        twoWay: true
    },
    title: {
        type: String,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    },
    pinElementOptions: {
        type: Object
    },
    label: {
        type: String,
    },
    icon: {
        type: String
    }
};

const events = [
    "click",
    "rightclick",
    "dblclick",
    "drag",
    "dragstart",
    "dragend",
    "mouseup",
    "mousedown",
    "mouseenter",
    "mouseleave"
];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
export default {
    mixins: [MapElementMixin, getPropsValuesMixin],
    props: props,

    render(h) {
        if (!this.$slots.default || this.$slots.default.length == 0) {
            return "";
        } else if (this.$slots.default.length == 1) {
            // So that infowindows can have a marker parent
            return this.$slots.default[0];
        } else {
            return h("div", this.$slots.default);
        }
    },
    watch: {
        pinElementOptions: {
            handler: async function () { 
                if (!this.$pinElement) return;
                Object.assign(this.$pinElement, this.pinElementOptions);
            },
            deep: true
        }
    },
    destroyed() {
        if (!this.$markerObject) return;

        if (this.$clusterObject) {
            this.$clusterObject.removeMarker(this.$markerObject);
        } else {
            this.$markerObject.setMap(null);
        }
    },

    deferredReady() {
        const options = _.mapValues(props, (value, prop) => this[prop]);
        options.map = this.$map;

        // search ancestors for cluster object
        let search = this.$findAncestor(ans => ans.$clusterObject);

        this.$clusterObject = search ? search.$clusterObject : null;
        this.createMarker(options);
    },

    methods: {
        async createMarker(options) {
            const { AdvancedMarkerElement, PinElement } = await window.google.maps.importLibrary("marker");
            if (options.icon) { 
                const iconElement = document.createElement('div');
                iconElement.innerHTML = `<i class="${options.icon}" style="font-size: 18px"></i>`;
                this.$pinElement = new PinElement({
                    glyph: iconElement,
                    ...options.pinElementOptions
                });
            }
            else {
                this.$pinElement = new PinElement(options.pinElementOptions);
            }
            //const parser = new DOMParser();
            // A marker with a custom inline SVG.
            //const pinSvgString = '<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg">' +
            //    '<g><rect stroke-width="2" id="svg_3" height="22" width="22" y="2" x="2" stroke="#000" fill="#fff"/>' +
            //    '<text transform="matrix(1 0 0 1 0 0)" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="24" id="svg_4" y="307.99998" x="394.33334" stroke-width="0" stroke="#000" fill="#000000"/>'+
            //    '<text transform="matrix(54.7145 0 0 17.995 -21313.6 -4842.24)" stroke="#000" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="24" id="svg_5" y="294.46887" x="390.99997" stroke-width="0" fill="#000000">1</text>'+
            //    '</g></svg>';
            //const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

            this.$markerObject = new AdvancedMarkerElement({
                map: options.map,
                position: options.position,
                title: options.title,
                draggable: options.draggable,
                zIndex: options.zIndex,
                content: this.$pinElement.element
            });

            //propsBinder(this, this.$markerObject, props);
            //eventsBinder(this, this.$markerObject, events);
            _.forEach(events, (eventName) => {
                const exposedName = eventName;
                this.$markerObject.content.addEventListener(eventName, (ev) => {
                    this.$emit(exposedName, ev);
                });
            })
        }
    }
};
